import script from "./EntitlementUsageTile.vue?vue&type=script&setup=true&lang=js"
export * from "./EntitlementUsageTile.vue?vue&type=script&setup=true&lang=js"

import "./EntitlementUsageTile.vue?vue&type=style&index=0&id=216d70fe&scoped=true&lang=css"
script.__scopeId = "data-v-216d70fe"

export default script